import { render, staticRenderFns } from "./AzureAuth.vue?vue&type=template&id=e8076d52"
import script from "./AzureAuth.vue?vue&type=script&lang=js"
export * from "./AzureAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8076d52')) {
      api.createRecord('e8076d52', component.options)
    } else {
      api.reload('e8076d52', component.options)
    }
    module.hot.accept("./AzureAuth.vue?vue&type=template&id=e8076d52", function () {
      api.rerender('e8076d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AzureAuth.vue"
export default component.exports